import srAKM2DVgZ from 'crypto-js'

const otmPKNWjy0 = import.meta.env.VITE_CRYPT_SECRET

export const getDecJson = <T>(crypted: T) =>
  JSON.parse(
    srAKM2DVgZ.AES.decrypt(crypted as string, otmPKNWjy0).toString(
      srAKM2DVgZ.enc.Utf8,
    ),
  ).content
